import React from "react";
import AboutImage from "../../images/about.jpg";

const AboutUsSection = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-green-50">
      <div className="flex flex-wrap items-center justify-between w-full max-w-6xl p-8 bg-white rounded-lg shadow-lg border border-green-100">
        <div className="w-full md:w-3/4 pr-4">
          <h1 className="text-5xl font-bold mb-6 text-green-800">Who We Are?</h1>
          <p className="text-gray-700 text-xl leading-relaxed">
            Welcome to EstateGhar! We revolutionize real estate by making property 
            transactions simple, transparent, and accessible. Whether you're looking to 
            buy, sell, rent, or invest in properties, our platform connects you with 
            verified listings and trusted partners. With cutting-edge technology and 
            personalized service, we're committed to helping you find your perfect space 
            and make informed real estate decisions. Join our community and experience 
            the future of property management today.
          </p>
          <div className="mt-6">
            <span className="inline-block px-4 py-2 bg-green-600 text-white rounded-lg font-semibold">
              Your Trusted Real Estate Partner
            </span>
          </div>
        </div>
        <div className="w-full md:w-1/4 mt-6 md:mt-0">
          <img
            src={AboutImage}
            alt="Modern real estate properties"
            className="w-full rounded-lg shadow-md border-2 border-green-200"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutUsSection;